import React, { useState, useEffect } from 'react';
import { useOrder } from '../order/OrderContext';

const PriceInfo = ({ model, onUpdate }) => {
    const { setCalculationStatus, showGrossPrices } = useOrder();

    // Lokalny stan dla wartości inputu (podczas wpisywania)
    const [localQuantity, setLocalQuantity] = useState(model.quantity);

    // Synchronizuj lokalny stan z modelem gdy zmienia się z zewnątrz (np. przyciski)
    useEffect(() => {
        setLocalQuantity(model.quantity);
    }, [model.quantity]);

    // Funkcja wysyłająca request do backendu
    const submitQuantityChange = (value) => {
        const quantity = parseInt(value) || 1;
        const newQuantity = Math.max(1, Math.min(50000, quantity));

        // Tylko jeśli wartość się rzeczywiście zmieniła
        if (newQuantity !== model.quantity) {
            setCalculationStatus(true);
            onUpdate({ quantity: newQuantity });
        }

        // Zaktualizuj lokalny stan do prawidłowej wartości
        setLocalQuantity(newQuantity);
    };

    // Handler dla przycisków +/- (natychmiastowa zmiana)
    const handleButtonClick = (newValue) => {
        const quantity = Math.max(1, Math.min(50000, newValue));
        setLocalQuantity(quantity);
        setCalculationStatus(true);
        onUpdate({ quantity });
    };

    // Handler dla wpisywania (tylko lokalny stan, bez requestu)
    const handleInputChange = (e) => {
        setLocalQuantity(e.target.value);
    };

    // Handler dla Enter
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.target.blur(); // Wymuś blur żeby onBlur się wykonał
        }
    };



    // Wybierz cenę netto lub brutto w zależności od checkboxa
    const unitPrice = showGrossPrices
    ? ((model.hasOversizedDimension || model.error) ? 0 : model.priceGross)
    : ((model.hasOversizedDimension || model.error) ? 0 : model.priceNet);

    const formattedUnitPrice = unitPrice ? unitPrice.toFixed(2) : '0.00';
    const currency = model.currency || 'PLN';

    // Pokaż poprzednią cenę total lub "obliczanie..." jeśli się przelicza
    const isRecalculating = model.isCalculating || false;
    const totalPrice = isRecalculating
    ? "obliczanie..."
    : (model.hasOversizedDimension || model.error)
    ? `0.00 ${currency}`
    : `${(unitPrice * model.quantity).toFixed(2)} ${currency}`;




    return (
        <div>
        {/* Ilość */}
        <div className="mb-2">
        <label className="config-section-label mb-1"> Liczba części </label>

        <div className="quantity-input-container">
        <button
        type="button"
        className="quantity-btn quantity-btn-minus"
        onClick={() => handleButtonClick(model.quantity - 1)}
        disabled={model.quantity <= 1 || model.isCalculating || model.hasOversizedDimension || model.error || model.priceError}
        >
        −
        </button>
        <input
        type="text"
        className="quantity-input"
        value={localQuantity}
        onChange={handleInputChange}
        onBlur={(e) => submitQuantityChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={model.isCalculating || model.hasOversizedDimension || model.error || model.priceError}
        />
        <button
        type="button"
        className="quantity-btn quantity-btn-plus"
        onClick={() => handleButtonClick(model.quantity + 1)}
        disabled={model.quantity >= 50000 || model.isCalculating || model.hasOversizedDimension || model.error || model.priceError}
        >
        +
        </button>
        </div>

        </div>



        {/* Cena */}
        <div className="price-container mt-3">
        <div className="price-total">

        {!isRecalculating && (
            <div className="text-small">
            {showGrossPrices ? 'Cena brutto (z VAT)' : 'Cena netto (bez VAT)'}
            </div>
        )}

        <div className="price-total-value"> {totalPrice} </div>
        {model.quantity > 1 && !isRecalculating && (
            <div className="text-small">
            {model.quantity} × {unitPrice} {currency}
            </div>
        )}
        </div>
        <div className="price-unit">
        <div className="text-small"> {formattedUnitPrice} {currency}/szt  </div>
        </div>
        </div>


        {/* Status - informacja o wycenie (gdy cena jeszcze nie jest dostępna) */}
        {model.priceNet === 0 && !model.error && !model.priceError && !model.isCalculating && !model.hasOversizedDimension && (
            <div className="text-small mt-2" style={{ color: '#666' }}>
            Wycena w trakcie...
            </div>
        )}
        </div>
    );
};

export default PriceInfo;
